const mediaItems = document.querySelectorAll(
  '.ss-section-product-slider-2-list-product .media-hover'
);

mediaItems.forEach(item => {
  item.addEventListener('click', () => {
    const id = item.dataset.product;

    mediaItems.forEach(el => el.classList.remove('active'));

    item.classList.add('active');

    document
      .querySelectorAll(
        '.ss-section-product-slider-2-list-product-infor .product-card-wrapper'
      )
      .forEach(b => b.classList.add('d-none'));

    const target = document.querySelector(
      `.ss-section-product-slider-2-list-product-infor 
       .product-card-wrapper[data-product="${id}"]`
    );

    if (target) {
      target.classList.remove('d-none');
    }
  });
});
